<div class="search" [class.bottom-border]="searchType === SearchType.ADVANCED" [resBusySpinner]="isSearchBusy"
    [message]="searchBusyMessage" data-automation-id="search-container">
    <div class="top-row">
        <div class="button-group">
            <button data-automation-id="freeform-button" type="button"
                [ngClass]="searchType === SearchType.FREEFORM ? 'btn-group-active' : 'btn-group-default'"
                (click)="setType(SearchType.FREEFORM)">
                <div>Freeform</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="searchType !== SearchType.FREEFORM"></i>
            </button>
            <button data-automation-id="advanced-button" type="button"
                [ngClass]="searchType === SearchType.ADVANCED ? 'btn-group-active' : 'btn-group-default'"
                (click)="setType(SearchType.ADVANCED)" [disabled]="disabledAdvanceSearch">
                <div>Advanced</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="searchType != 'ADVANCED'"></i>
            </button>
            <button data-automation-id="bulk-button" type="button"
                [ngClass]="isBulkSearch() ? 'btn-group-active' : 'btn-group-default'"
                (click)="setType(SearchType.BULK)">
                <div>Bulk</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="!isBulkSearch()"></i>
            </button>
        </div>

        <button type="button" [hidden]="!isBulkSearch()" class="secondary-button validate-bulk-queries"
            (click)="validateBulkQueries()" data-automation-id="bulk-validate-button"
            [disabled]="!bulkSearchComponent || !bulkSearchComponent.isValidateEnabled()">
            <i class="fa fa-check"></i>
            <span>Validate</span>
        </button>

        <res-collapsible-toggle-box-group [hidden]="searchType !== SearchType.FREEFORM"
            [style.min-width.px]="toggleWidth" [style.max-width.px]="toggleWidth"
            [activated]="searchType === SearchType.FREEFORM" [toggleItems]="freeFormToggles"
            [data-automation-id]="'freeformToggles'">
        </res-collapsible-toggle-box-group>

        <res-collapsible-toggle-box-group [hidden]="searchType !== SearchType.ADVANCED" [isAdvancedSearch]="true"
            [displayAlwaysOnRight]="workflowMode ? false : true" [style.min-width.px]="toggleWidth"
            [style.max-width.px]="toggleWidth" [activated]="searchType === SearchType.ADVANCED"
            [toggleItems]="advancedToggles" [data-automation-id]="'advancedToggles'">
        </res-collapsible-toggle-box-group>

        <button type="button" class="primary-button search-button" (click)="search()" [disabled]="isSearchDisabled()"
            *ngIf="!workflowMode" data-automation-id="search-button">Search</button>

        <span *ngIf="!workflowMode">in</span>

        <div class="target-picker" *ngIf="!workflowMode">
            <input type="text" title="{{target.name}}" readonly class="read-only" [ngModel]="target.name"
                data-automation-id="select-target-label">
            <i class="fa fa-filter filter-indicator" data-automation-id="data-sets-filter-indicator"
                [title]="corporaFilterTooltip" *ngIf="corporaFilters && corporaFilters.length > 0"></i>
            <div class="paired-buttons button-group dropdown" dropdown>
                <button type="button" class="primary-button target-button" [disabled]="!projectWasLoaded()"
                    [ngClass]="{'thin-button': selectTargetFullLabelVisible() ? false : true}" (click)="launchPicker()"
                    data-automation-id="target-button">
                    <i class="fa fa-crosshairs"></i>
                    <span *ngIf="selectTargetFullLabelVisible()">Select Target ...</span>
                </button>
                <button type="button" blur dropdownToggle class="primary-button show-menu-button"
                    data-automation-id="target-show-menu-button" onclick="this.blur();">
                    <i class=" fa fa-caret-down" data-automation-id="target-show-menu-icon"></i></button>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                    <li (click)="setTarget(currentSearch)" [ngClass]="{'disabled' : !isCurrentResultsEnabled() }"
                        class="menu-item" data-automation-id="current-search-results-button">
                        <i class="fa fa-search-plus color-tan-07 menu-item-icon"></i>
                        <label class="menu-item-label">Current Results</label>
                    </li>
                </ul>
            </div>
        </div>

        <button type="button" class="help-button" *ngIf="!workflowMode" data-automation-id="search-help-button"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>

    </div>

    <div class="query-row" [hidden]="searchType !== SearchType.FREEFORM">
        <div class="sticky">
            <button [hidden]="!queryString?.trim()" data-automation-id="freeform-clear-button"
                (click)="clearFreeFormQuery()">
                <i class=" fa fa-times"></i>
            </button>
        </div>
        <res-generic-input #input [colorizeOnQueryChange]="true" [workflowMode]="workflowMode"
            [automationId]="'freeform'" [inputChangedEvent]="inputChanged.bind(this)" [showMetadataSuggestions]="true"
            [keyPressEvent]="keyPressEvent.bind(this)" (click)="freeformSearchExceedsLimitAlert()"></res-generic-input>
    </div>
    <div class="advance-query-row" *ngIf="searchType === SearchType.ADVANCED">
        <button type="button" class="primary-button new-button" [class.thin]="!widestButtons()" (click)="newQuery()"
            data-automation-id="add-new-query-button">
            <i class="fa fa-plus color-green-04"></i>
            <span *ngIf="widestButtons()">New ...</span>
        </button>

        <button type="button" data-automation-id="edit-free-query-button" class="primary-button edit-free-button"
            [class.thin]="!wideButtons()" [disabled]="isNewQueryDisabled()" (click)="freeformSearchRedirect()">
            <i class="fa fa-pencil fa-stack-1x color-blue-01"></i>
            <span class="overlay">F</span>
            <span *ngIf="wideButtons()">Edit in Freeform</span>
        </button>

        <button type="button" data-automation-id="edit-query-button" class="primary-button edit-button"
            [class.thin]="!widestButtons()" (click)="editQuery()" [disabled]="isNewQueryDisabled()">
            <i class="fa fa-pencil color-blue-01"></i>
            <span *ngIf="widestButtons()">Edit ...</span>
        </button>

        <input type="text" title="{{advancedQuery.query}}" readonly [ngModel]="advancedQuery.query"
            [class.filled]="advancedQuery.query && advancedQuery.query.trim()" data-automation-id="advanced-query-text">
        <button [hidden]="!(advancedQuery.query && advancedQuery.query.trim())" class="x-button"
            data-automation-id="advanced-clear-button" (click)="clearAdvanceQuery()">
            <i class="fa fa-times"></i>
        </button>
    </div>
    <res-bulk-search [hidden]="!isBulkSearch()" [isBulkVisible]="isBulkSearch()" [workflowMode]="workflowMode"
        [customizeClass]="true">
    </res-bulk-search>
</div>